import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
//
// import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';

import DashboardAppPage from './pages/DashboardAppPage';
import PslCorp from './pages/PslCorp';
import CallHistory from './pages/CallHistory';
import SignupPage from './pages/SignupPage';
import Transaction from './components/Transaction/Transaction';
import Billing from './components/Billing/Billing';

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/" />, index: true },
        { path:'pslcorp', element:<PslCorp/> },
        { path:'callhistory', element:<CallHistory/> },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'billing', element: <Billing /> },
        { path: 'transaction', element: <Transaction /> },
      ],
    },
    {
      path: '/',
      element: <DashboardAppPage />,
    },
    {
      path: 'signup',
      element: <SignupPage />,
    },
    {
      path: '*',
      element: <Page404 /> ,
    },
  ]);

  return routes;
}
